import { Outlet, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { User, BarChart3, LogOut } from 'lucide-react';

const navItems = [
  { path: '/profile', icon: User, label: 'Profile' },
  { path: '/survey-data', icon: BarChart3, label: 'Survey Data' },
];

function Layout({ onLogout }) {
  const location = useLocation();
  const navigate = useNavigate();

  const activeItem = navItems.find((item) => location.pathname.startsWith(item.path));
  const pageTitle = activeItem?.label ?? 'Profile';

  return (
    <div className="mx-auto flex min-h-screen w-full max-w-md flex-col bg-white shadow-xl">
      <header className="flex items-center justify-between border-b border-slate-200 px-4 py-3">
        <h1 className="text-lg font-semibold text-slate-800">{pageTitle}</h1>
        <button
          type="button"
          onClick={() => {
            onLogout();
            navigate('/login');
          }}
          className="rounded-full p-2 text-slate-600 transition hover:bg-slate-100"
          aria-label="Logout"
        >
          <LogOut className="h-5 w-5" />
        </button>
      </header>

      <main className="flex-1 overflow-y-auto bg-slate-50 p-4 pb-20">
        <Outlet />
      </main>

      <nav className="fixed bottom-0 left-1/2 w-full max-w-md -translate-x-1/2 border-t border-slate-200 bg-white px-4 py-2">
        <ul className="flex justify-around">
          {navItems.map(({ path, icon: Icon, label }) => (
            <li key={path}>
              <NavLink
                to={path}
                className={({ isActive }) =>
                  `flex flex-col items-center gap-1 px-3 py-2 text-xs ${
                    isActive ? 'text-brand-accent' : 'text-slate-500'
                  }`
                }
              >
                <Icon className="h-5 w-5" />
                <span>{label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}

export default Layout;
